import { Auth } from '@common/Auth'
import {
  NORMAL_PRIVILEGE,
  NORMAL_SERVICE_PRIVILEGE,
  STORE_PRIVILEGE,
  PRIVILEGE_STORE_SERVICE_ID,
  PRIVILEGE_STORE_ID,
  PRIVILEGE_NORMAL_SERVICE_ID,
  PRIVILEGE_NORMAL_ID,
  STORE_SERVICE_PRIVILEGE,
  // ROLE_SERVICE,
  PRIVILEGE_GROUP_ID,
  GROUP_PRIVILEGE
} from '@constant'
import { getMerchantInfo } from '..'
import { Modal } from 'hljd'
import { hashHistory } from 'react-router'
import { isSiDaTeam } from './property'
import {
  __JTI__,
  __MAIN_JTI__,
  __JWT__,
  __MAIN_JWT__
} from '@merchant-backend/constant'
import { isRoleService } from '@util'

export const AuthRoute = config => Auth({ ...config, type: 'route' })

/**
 * 获取有权限控制的路由组件
 */
export const getRouteComponent = (Component, config) => (s, cb) => {
  cb(null, AuthRoute(config)(Component))
}

/**
 * 是否店铺被禁  0不隐藏 1运营隐藏 2数据隐藏 3商家隐藏
 */
export const isStoreHidden = () => {
  const { hidden } = getMerchantInfo()
  if (hidden == '1' || hidden == '2') {
    return '您的店铺违反平台规定已被封禁，如有疑问请联系婚礼纪客服！'
  } else if (hidden == '3') {
    return '您已将此店铺隐藏！'
  } else {
    return 'success'
  }
}

/**
 * 是否是加盟店账号
 */
export const isStoreAccount = () => {
  return getMerchantInfo().is_franchisee == '1'
}

/**
 * 登录的账号可能有两种大的账号类型：管理员和客服
 * 系统包含加盟店/体验店 和 本地商家两种商家类型
 * 加盟店/体验店 和 本地商家都有管理员和客服角色（共4个角色）
 * 系统中给这四个角色定义了权限 id
 * export const PRIVILEGE_NORMAL_ID = 1 // 本地商家管理员
   export const PRIVILEGE_STORE_ID = 2 // 加盟店/体验店管理员
   export const PRIVILEGE_NORMAL_SERVICE_ID = 3 // 本地商家客服
   export const PRIVILEGE_STORE_SERVICE_ID = 4 // 加盟店/体验店客服
 */
export const getAuthId = () => {
  if (isSiDaTeam()) {
    return PRIVILEGE_GROUP_ID
  }

  // 是客服账号
  const isService = isRoleService()

  if (isStoreAccount()) {
    return isService ? PRIVILEGE_STORE_SERVICE_ID : PRIVILEGE_STORE_ID
  }

  return isService ? PRIVILEGE_NORMAL_SERVICE_ID : PRIVILEGE_NORMAL_ID
}

/**
 * 获取当前账号指定功能权限（如菜单）
 * @param {String} key 指定功能key：menu | storeExtends | qualityService
 */
export const getAuthList = key => {
  const id = getAuthId()
  switch (id) {
    case PRIVILEGE_NORMAL_ID:
      return NORMAL_PRIVILEGE[key]
    case PRIVILEGE_NORMAL_SERVICE_ID:
      return NORMAL_SERVICE_PRIVILEGE[key]
    case PRIVILEGE_STORE_ID:
      return STORE_PRIVILEGE[key]
    case PRIVILEGE_STORE_SERVICE_ID:
      return STORE_SERVICE_PRIVILEGE[key]
    case PRIVILEGE_GROUP_ID:
      return GROUP_PRIVILEGE[key]
    default:
      return NORMAL_PRIVILEGE[key]
  }
}

export const notBondAlert = () => {
  Modal.confirm({
    title: '该功能需开通缴纳放心购·保证金后方可使用',
    iconType: 'info-circle-o',
    okText: '了解详情',
    cancelText: '关闭',
    onOk() {
      hashHistory.push('/localMerchant/marketingCenter/detail/gurantee')
    }
  })
}

/**
 * 是否是体验店
 */
export const isExperienceStore = () => {
  const { is_experience } = getMerchantInfo()
  return is_experience > 0
}

/**
 * 所有类目管理员、客服（非加盟店、团队账号）
 */
export const isNormalRole = () => {
  const authId = getAuthId()
  return authId == PRIVILEGE_NORMAL_ID || authId == PRIVILEGE_NORMAL_SERVICE_ID
}

/**
 * 获取 jti
 */
export const getJti = isMainMerchant => {
  const { shop_type } = getMerchantInfo()
  let key = __JTI__

  if (isMainMerchant || shop_type == 5) {
    key = __MAIN_JTI__
  }

  return localStorage.getItem(key)
}

/**
 * 获取 jwt
 */
export const getJwt = isMainMerchant => {
  const { shop_type } = getMerchantInfo()
  let key = __JWT__

  if (isMainMerchant || shop_type == 5) {
    key = __MAIN_JWT__
  }

  return JSON.parse(localStorage.getItem(key) || '{}').token
}

/**
 * 商家入驻审核未通过
 */
export const isNotExamined = () => {
  return getMerchantInfo().examine != 1
}
